module.exports = __webpack_public_path__ + "static/media/Girls-Bed1.eb02d2f1.webp";